import axios from './financeiroApi';

const parametrosNotaFiscalApi = () => {
  const getPath = () => {
    return `/api/v1/backend/parametros/nota-fiscal`;
  };

  return {
    getParametrosNotaFiscalEmpresa: () => {
      const url = getPath();
      return axios.get(url);
    },

    cadastrar: (parametrosNotaFiscal) => {
      const url = getPath();
      return axios.post(url, parametrosNotaFiscal);
    },

    atualizar: (id, parametrosNotaFiscal) => {
      const url = `${getPath()}/${id}`;
      return axios.put(url, parametrosNotaFiscal);
    },

    uploadCertificado: async (certificado) => {
      return axios.put(`${getPath()}/certificado/upload`, certificado, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    },
    removerCertificado: async (parametrosNotaFiscal) => {
      return axios.put(`${getPath()}/certificado/remover`, parametrosNotaFiscal);
    },
  };
};

export { parametrosNotaFiscalApi };
